import {
  checkTransmittalAccessRequest,
  getTransmittalAttachedFilesRequest,
  getTransmittalDataByIdRequest,
  getTransmittalFileVersionsForSpaceRequest,
  saveTransmittalsDataRequest,
} from "@Features/transmittals/api/transmittals.api";
import {
  setTransmitalsData,
  setTransmitalMetadata,
  setTransmittalAccess,
  setTransmittalVersions,
  setTransmittalDataForReviews,
  setTransmittalReferences,
  mergeTransmitalsData,
} from "../state/transmitals.reducer";
import type {
  GetFilesAttachedToTransmittalRequest,
  GetTransmittalDataByIdRequest,
  GetTransmittalFileVersionsForSpaceRequest,
  IsTransmittal403Request,
  SaveTransmittalsRequest,
} from "@ServerTypes/transmittals/transmittals.schema";
import type { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import type { RootState } from "src/reducers";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

type AppDispatch = ThunkDispatch<RootState, unknown, UnknownAction>;

export async function saveTransmitalsData(data: SaveTransmittalsRequest) {
  return await saveTransmittalsDataRequest(data);
}

export async function getTransmittalAttachedFiles(data: GetFilesAttachedToTransmittalRequest) {
  return await getTransmittalAttachedFilesRequest(data);
}

export function getTransmittalAccess(data: IsTransmittal403Request) {
  return async (dispatch: AppDispatch) => {
    const responseData = await checkTransmittalAccessRequest(data);
    if (responseData.data.status) {
      dispatch(setTransmittalAccess(responseData.data));
    }
  };
}

export {
  setTransmitalsData,
  setTransmitalMetadata,
  setTransmittalAccess,
  setTransmittalDataForReviews,
  setTransmittalReferences,
  mergeTransmitalsData,
};

export function getTransmittalFileVersionsForSpace(data: GetTransmittalFileVersionsForSpaceRequest) {
  return async (dispatch: AppDispatch) => {
    const responseData = await getTransmittalFileVersionsForSpaceRequest(data);
    if (responseData.data) {
      dispatch(setTransmittalVersions(responseData.data));
    }
  };
}

export function getTransmittals(params: { transmittalVersionId?: string }) {
  return async (dispatch: AppDispatch) => {
    let postData = {} as GetTransmittalDataByIdRequest;

    // Entry point: this action's public contract takes a plain `string` because DesignViewer.tsx
    // calls it with a raw `URLSearchParams.get("transmittalId")` value, which the type system
    // cannot see into. Asserted once here, at the declaration.
    const transmittalId = params.transmittalVersionId as ObjectIdString | undefined;
    if (transmittalId) {
      postData = { transmittalId };
    }
    await getTransmittalDataByIdRequest(postData).then((response) => {
      if (response.data.status) {
        dispatch(setTransmitalsData(response.data.data));
        if (response.data.metadata) {
          dispatch(setTransmitalMetadata(response.data.metadata));
        }
      }
    });
  };
}
